<script setup lang="ts">
  import HeaderAiButton from '@/components/header/AiButton.vue';

  defineProps({
    isMobile: {
      type: Boolean,
      default: false
    }
  });

  const chatStore = useChatStore();
  const { isAiMode } = storeToRefs(chatStore);
</script>

<template>
  <header class="app-header">
    <div class="container mx-auto">
      <div class="app-header__wrapper">
        <div class="app-header__bg">
          <div class="app-header__top">
            <div class="app-header__left">
              <NuxtLinkLocale
                class="app-header__logo"
                to="/">
                <img
                  src="~/assets/images/logo-magenta.svg"
                  alt="logo" />
              </NuxtLinkLocale>
              <div
                v-if="!isAiMode"
                class="app-header__locale">
                <slot name="left" />
              </div>
            </div>
            <div class="app-header__center">
              <slot name="center" />
            </div>
            <div class="app-header__right">
              <HeaderAiButton />
            </div>
          </div>
          <div
            v-if="isMobile && !isAiMode"
            class="app-header__bottom">
            <slot name="bottom" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
